function HomeErrorBanner({ loadError }) {
  if (!loadError) {
    return null;
  }

  return (
    <section className="mx-auto w-[min(1120px,calc(100%-40px))] py-2">
      <div className="rounded-[20px] border border-[#9c3d2d33] bg-[rgba(255,245,242,0.9)] px-5 py-4 text-[#8a2e20]">
        Klarte ikke laste innhold fra serveren: {loadError}
      </div>
    </section>
  );
}

export default HomeErrorBanner;